import * as Highcharts from "highcharts";
import { checkWindowSize } from "@utils/utils";

export const commonChartOptions: Highcharts.Options = {
    title: {
        text: ''
    },
    chart: {
        zooming: {
            type: 'x',
            resetButton: {
                theme: {
                    zIndex: 1000
                }
            },
            // @ts-ignore
            mouseWheel: {
                enabled: false
            }
        },
        height: checkWindowSize(1500, 500),
    },
    legend: {
        enabled: false
    },
}